import { useState, useCallback, useEffect, useRef } from "react";
import { Dimensions } from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import { useAuth0 } from "@auth0/auth0-react";
import Storage from "@lib/utilities/storage/StorageFunctions";
import CheckSession from "@lib/utilities/CheckSession";
import { handleInvalidTokenCase } from "@lib/utilities/AuthHelper";
import AppConstants, { isActionTabsLayout } from "@lib/utilities/Constants";
import { POLICY_ACTION_ROUTE } from "../../../src/navigation/NavigationConstants";
import Crashlytics from "@lib/utilities/crashlyticsUtils/CrashlyticsUtils";
import { messages } from "../../../src/resources/strings";
import { bannerHandler } from "@lib";
import { useAppSelector } from "@lib";

export const usePolicyActions = (
  policyData: any,
  navigation: any,
  route: any,
) => {
  const { logout } = useAuth0();
  const { banner, isConnected } = useAppSelector((state) => state.userReducer);

  const [errorHandle, setErrorHandle] = useState(messages.error.noError);
  const [isLandscape, setIsLandScape] = useState(false);
  const connectionRef = useRef(false);
  const isActionTabs = isActionTabsLayout();
  const { fetchBanner, closeBanner } = bannerHandler();

  const handleInvalidToken = () => {
    handleInvalidTokenCase(isConnected ?? false, navigation, logout, () => {
      setErrorHandle(messages.error.youAreOffline);
    });
  };

  const orientationListner = () => {
    Dimensions.addEventListener("change", (res) => {
      if (res?.screen?.height < res?.screen?.width) {
        setIsLandScape(true);
      } else {
        setIsLandScape(false);
      }
    });
  };

  const checkSession = useCallback(async () => {
    const session = await CheckSession();
    if (session) {
      // fetchBanner();
      orientationListner();
    } else handleInvalidToken();
  }, []);

  const navigationToInnerScreens = async (
    screenName: string,
    navigateTo: string,
  ) => {
    if (connectionRef.current) {
      Storage.storeData(
        AppConstants.LocalStoreConstant.CURRENT_LOADED_SCREEN,
        screenName,
      );
      navigation.navigate(navigateTo);
    } else {
      setErrorHandle(messages.error.youAreOffline);
    }
  };

  const onReloadPress = () => {
    setErrorHandle(messages.error.noError);
    checkSession();
  };
  const onEndTimer = () => {
    setErrorHandle(messages.error.noError);
  };
  useFocusEffect(
    useCallback(() => {
      Crashlytics.logScreen(POLICY_ACTION_ROUTE);
      checkSession();
    }, [route, policyData, checkSession]),
  );

  useEffect(() => {
    if (isConnected) {
      connectionRef.current = true;
    } else {
      connectionRef.current = false;
    }
  });

  return {
    banner,
    errorHandle,
    setErrorHandle,
    bannerCloseAction: closeBanner,
    navigationToInnerScreens,
    isLandscape,
    onEndTimer,
    onReloadPress,
    isActionTabs,
  };
};
